import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import { nowIsoAndUnix } from "@@/shared/date-time/iso-and-unix";
import type { Message } from "@@/shared/messages/message";
import type { OrderId } from "@@/shared/orders/order-id";
import type { Price } from "@@/shared/prices/price";
import type { Translatable } from "@@/shared/translations/translation";
import type { Except } from "type-fest";
import type { ResourceReservation } from "./resource-reservation";

type TimelineResourceReservationOrderData = {
    orderId: OrderId;
    hasOrderMessages: boolean;
    orderMessages: Message[];
    hasExtras: boolean;
    hasAmountUnpaid: boolean;
    isOnPremiseOrder: boolean;
    customerName: Translatable;
    mainOrderItemTitleForResourceReservation: Translatable;
    totalPrice: Price;
};

type TimelineResourceReservation = {
    _createdAt: IsoAndUnixTimestamp;
    _type: "TIMELINE___RESOURCE_RESERVATION";
    resourceReservation: ResourceReservation;
    orderData: TimelineResourceReservationOrderData | undefined | null;
};

const isTimelineResourceReservation = (
    item: unknown,
): item is TimelineResourceReservation => {
    return (
        (item as TimelineResourceReservation)?._type ===
        "TIMELINE___RESOURCE_RESERVATION"
    );
};

const timelineResourceReservationFactory = (
    data: Except<TimelineResourceReservation, "_createdAt" | "_type">,
): TimelineResourceReservation => {
    return {
        _createdAt: nowIsoAndUnix(),
        _type: "TIMELINE___RESOURCE_RESERVATION",
        ...data,
    };
};

export { isTimelineResourceReservation, timelineResourceReservationFactory };
export type {
    TimelineResourceReservation,
    TimelineResourceReservationOrderData,
};
